<template>
  <div>
    <portal to="toolbar-title"> Αρχική</portal>
    <home-mobile v-if="isMobile"></home-mobile>
    <home-desktop v-else></home-desktop>
  </div>
</template>

<script>
import HomeDesktop from "@/views/Dashboards/views/HomeDesktop"
import HomeMobile from "@/views/Dashboards/views/HomeMobile"
import {mapGetters} from "vuex";

export default {
  name: "Home",
  computed: {
    ...mapGetters([
      'isMobile'
    ])
  },
  components: {
    HomeDesktop,
    HomeMobile,
  },
}
</script>

<style scoped>

</style>
